import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {TabSelectionService} from '../../../../common/services/tab-selection.service';
import {PharmacyRoutesQueryParam as QueryParam} from '../../../../common/types/routes-query-param.enum';

enum Tab {
  NationalDrugs,
  ExternalDrugData,
  MasterDrugs,
  DrugInteractions,
  NationalDrugFormularies,
  DrugManagementPlans,
  Manufacturers,
  Ingredients,
  ATCCodes,
}

const TabQueryParamByIndexNo = {
  [Tab.NationalDrugs]: QueryParam.NationalDrugs,
  [Tab.ExternalDrugData]: QueryParam.ExternalDrugData,
  [Tab.MasterDrugs]: QueryParam.MasterDrugs,
  [Tab.DrugInteractions]: QueryParam.DrugInteractions,
  [Tab.NationalDrugFormularies]: QueryParam.NationalDrugFormularies,
  [Tab.DrugManagementPlans]: QueryParam.DrugManagementPlans,
  [Tab.Manufacturers]: QueryParam.Manufacturers,
  [Tab.Ingredients]: QueryParam.Ingredients,
  [Tab.ATCCodes]: QueryParam.ATCCodes,
};

@Component({
  selector: 'app-pharmacy-management-view',
  templateUrl: './pharmacy-management-view.component.html',
  styleUrls: [
    '../../../../../../styles/global/_management-styles.scss'
  ],
})
export class PharmacyManagementViewComponent implements OnInit, OnDestroy {
  readonly destroyed$ = new Subject();

  activeTabName = 'National Drugs';
  activeTabIndex = 0;

  private currentTab: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private tabSelectionService: TabSelectionService,
  ) {
  }

  ngOnInit(): void {
    this.initSubscriptions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initSubscriptions() {
    this.tabSelectionService.currentTab$AsObservable
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((currentTab: string) => {
      this.currentTab = currentTab;
      this.selectTab(currentTab);
    });
  }

  selectTab(tabName: string): void {
    if (tabName === QueryParam.NationalDrugs) {
      this.activeTabIndex = Tab.NationalDrugs;
      this.activeTabName = 'National Drugs';
    }
    else if (tabName === QueryParam.ExternalDrugData) {
      this.activeTabIndex = Tab.ExternalDrugData;
      this.activeTabName = 'External Drug Data';
    }
    else if (tabName === QueryParam.MasterDrugs) {
      this.activeTabIndex = Tab.MasterDrugs;
      this.activeTabName = 'Master Drugs';
    }
    else if (tabName === QueryParam.DrugInteractions) {
      this.activeTabIndex = Tab.DrugInteractions;
      this.activeTabName = 'Drug Interactions';
    }
    else if (tabName === QueryParam.NationalDrugFormularies) {
      this.activeTabIndex = Tab.NationalDrugFormularies;
      this.activeTabName = 'National Drug Formularies';
    }
    else if (tabName === QueryParam.DrugManagementPlans) {
      this.activeTabIndex = Tab.DrugManagementPlans;
      this.activeTabName = 'Drug Management Plans';
    }
    else if (tabName === QueryParam.Manufacturers) {
      this.activeTabIndex = Tab.Manufacturers;
      this.activeTabName = 'Manufacturers';
    }
    else if (tabName === QueryParam.Ingredients) {
      this.activeTabIndex = Tab.Ingredients;
      this.activeTabName = 'Ingredients';
    }
    else if (tabName === QueryParam.ATCCodes) {
      this.activeTabIndex = Tab.ATCCodes;
      this.activeTabName = 'ATC Codes';
    }
  }

  onTabSelectionChanged($event: MatTabChangeEvent) {
    this.router.navigate(['/pharmacy-management'], {
      queryParams: {tab: TabQueryParamByIndexNo[$event.index]},
    });
  }

}
